import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function FlightOutboundFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.90594 21.2558C1.90594 20.8458 2.24594 20.5058 2.67594 20.5058H21.1459C21.5759 20.5058 21.9159 20.8458 21.9159 21.2558C21.9159 21.6658 21.5759 22.0058 21.1459 22.0058H2.67594C2.24594 22.0058 1.90594 21.6658 1.90594 21.2558Z"
				fill="currentColor"
			/>
			<path
				d="M17.5255 4.49105C18.5452 4.32081 19.717 4.50363 20.5499 4.95216L21.6009 5.50709L21.6161 5.51513L22.1695 5.82319C23.4534 6.5885 23.2907 7.97753 21.9108 8.44617L21.2892 8.6435L16.6416 10.056L11.8039 16.1282C11.7133 16.2418 11.5879 16.3238 11.4476 16.3615L8.65934 17.111C8.41079 17.1775 8.14553 17.0976 7.97455 16.9053C7.80354 16.7129 7.75596 16.4399 7.85129 16.2008L9.67772 11.6233L5.59531 12.1933C5.37741 12.2237 5.15785 12.1465 5.00666 11.9867L1.56124 8.34395C1.39523 8.1682 1.33469 7.91757 1.40264 7.68555C1.4708 7.45332 1.65812 7.27419 1.89306 7.21609L4.31148 6.61857L4.38183 6.60465C4.54566 6.58205 4.7132 6.62024 4.85218 6.71284L6.16262 7.58736L9.48529 6.6778L9.48322 6.67536L16.6922 4.70362L16.6918 4.70167L17.2889 4.53838L17.3058 4.53402L17.3236 4.5299L17.5255 4.49105Z"
				fill="currentColor"
			/>
			<path
				d="M9.20045 2.12511L13.4869 4.16943L8.44528 5.54813L6.62076 3.56762C6.45472 3.38743 6.39778 3.13165 6.47263 2.89839C6.54778 2.66516 6.74295 2.48976 6.98288 2.44015L8.77032 2.07269L8.87937 2.05881C8.98945 2.05431 9.10001 2.07723 9.20045 2.12511Z"
				fill="currentColor"
			/>
		</svg>
	);
}

FlightOutboundFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default FlightOutboundFilledIcon;
